import { render, staticRenderFns } from "./PostsCalendar.vue?vue&type=template&id=1bcc3f38"
import script from "./PostsCalendar.vue?vue&type=script&lang=js"
export * from "./PostsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcc3f38')) {
      api.createRecord('1bcc3f38', component.options)
    } else {
      api.reload('1bcc3f38', component.options)
    }
    module.hot.accept("./PostsCalendar.vue?vue&type=template&id=1bcc3f38", function () {
      api.rerender('1bcc3f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PostsCalendar.vue"
export default component.exports